module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/godfrey-d6b553c1e8dd0541dbc8560f7549d788.mp3";